export default __webpack_public_path__ + "static/media/flag-bolivia.25f20a9b.svg";